import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import amount from "amount";

const Line = props => {
  const [options, setOptions] = useState({});
  const [series, setSeries] = useState([]);

  useEffect(() => {
    if (!props || !props.categories) return;

    setOptions({
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      stroke: {
        curve: "straight"
      },
      tooltip: {
        y: {
          formatter: function(value) {
            if (props.isAmount) {
              return amount.currency(value, "USD");
            }

            return value;
          }
        }
      },
      xaxis: {
        categories: props.categories
      },
      yaxis: {
        labels: {
          formatter: value => {
            if (props.isAmount) {
              return amount.currency(value, "USD");
            }

            return value;
          }
        }
      }
    });

    if (props.seriesMultiple) {
      setSeries(props.seriesMultiple);
    } else {
      setSeries(props.series);
    }
  }, [props]);

  return <Chart options={options} series={series} type="line" width="100%" />;
};

export default Line;
